module.exports = new __parcel__URL__("no_full_screen.3e27e68f.png").toString();